
import { DialogTitle } from "@/components/ui/dialog";

interface AnalysisModalHeaderProps {
  title: string;
  overallScore: number | null;
}

export const AnalysisModalHeader = ({ title, overallScore }: AnalysisModalHeaderProps) => {
  return (
    <div className="py-4 px-6 bg-[#0d2456] border-0 flex items-center justify-between">
      <DialogTitle className="text-xl font-medium text-white text-center flex-1">
        {title}
      </DialogTitle>
      
      {overallScore && (
        <div className="flex items-center">
          <div className="text-xl font-bold text-white">
            {typeof overallScore === 'number' 
              ? `Score: ${Math.round(overallScore)}%`
              : overallScore}
          </div>
        </div>
      )}
    </div>
  );
};
